import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import defaultConfig from '../AppContextProvider/defaultConfig';
import {YSTextDark} from '../AppContextProvider/YSTheme';

export const triggerCSVDownload = (rows, headers, fileName) => {
  const headerLabels = headers.map((h) => h.label).join(',');

  const rowString = rows
    .map((row) =>
      headers
        .map((header) => {
          const value = row[header.key] !== undefined ? row[header.key] : '';
          return `"${value}"`; // Quote-wrap to handle commas in data
        })
        .join(','),
    )
    .join('\n');

  const csvContent = `${headerLabels}\n${rowString}`;
  const blob = new Blob([csvContent], {type: 'text/csv;charset=utf-8;'});

  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.setAttribute('href', url);
  link.setAttribute('download', fileName);
  link.style.visibility = 'hidden';

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const triggerPDFDownload = (rows, headers, fileName) => {
  const doc = new jsPDF({orientation: 'landscape'});
  const palette = defaultConfig.theme.palette;

  const tableHeaders = [headers.map((h) => h.label.toUpperCase())];
  const tableData = rows.map((row) =>
    headers.map((header) => row[header.key] || ''),
  );

  autoTable(doc, {
    head: tableHeaders,
    body: tableData,
    startY: 25,
    theme: 'plain',
    headStyles: {
      fillColor: palette.secondary.main,
      textColor: YSTextDark.primary,
      fontSize: 9,
      fontStyle: 'bold',
      cellPadding: 4,
    },
    bodyStyles: {
      fontSize: 8,
      textColor: palette.secondary.main,
      cellPadding: 3,
      lineColor: defaultConfig.theme.palette.gray[300], // Light grey for precision grid lines
      lineWidth: 0.1,
    },
    alternateRowStyles: {
      fillColor: palette.background.default, // YAMAN_PEARL_BG
    },
    columnStyles: {
      // Highlight IDs in Gold to match the "Ignition" theme
      0: {fontStyle: 'bold', textColor: palette.primary.main},
    },
    margin: {left: 14, right: 14},
    didDrawPage: (data) => {
      // Footer: Page Numbers in secondary grey
      doc.setFontSize(8);
      doc.setTextColor(palette.text.secondary);
      doc.text(
        `Page ${data.pageNumber}`,
        doc.internal.pageSize.width - 25,
        doc.internal.pageSize.height - 10,
      );
    },
  });

  doc.save(`${fileName}.pdf`);
};
